import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserId } from 'store/session/selectors';
import { useNavigate, useParams } from 'react-router-dom';
import isNull from 'lodash/isNull';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { CreateAppointmentForm } from 'components/Appointments/CreateAppointmentForm';
import { AppointmentFormData, AppointmentStatus } from 'types/appointment';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { createUserAppointment, getAppointmentById, updateUserAppointment } from 'services/appointmentService';
import { PATH } from 'routes/path';
import { useDidMount } from 'hooks/useDidMount';
import { APPOINTMENT_DATE_CONFIRM_STATUS } from 'pages/Appointments/constants';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const EditAppointmentPage = () => {
    const userId = useSelector(getUserId);
    const [isLoading, setIsLoading] = useState(true);
    const [status, setStatus] = useState<AppointmentStatus | null>(null);
    const [initialData, setInitialData] = useState<AppointmentFormData | null>(null);

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const updateHandler = (form: AppointmentFormData) => {
        setIsLoading(true);
        if (id) {
            updateUserAppointment(id, form)
                .then(() => {
                    notifications.show({ message: 'Appointment successfully updated' });
                    navigate(PATH.APPOINTMENTS);
                })
                .finally(() => setIsLoading(false));
        }
    };

    useDidMount(() => {
        if (id) {
            getAppointmentById(id)
                .then((data) => {
                    setInitialData(data.data);
                    setStatus(data.status);
                })
                .finally(() => setIsLoading(false));
        }
    });

    if (isNull(initialData)) {
        return <BackdropLoader />;
    }

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Appointment" sx={cardStyles}>
                <CreateAppointmentForm
                    initialData={initialData}
                    disabledDateTime={status !== APPOINTMENT_DATE_CONFIRM_STATUS}
                    onCreate={updateHandler}
                />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
